module.exports = __webpack_public_path__ + "static/media/banner8.aa78e679.jpg";